import { DeleteAccountRequest, SupportRequest } from 'services/supportService';

export const prepareHelpRequest = (request: ZendeskHelpRequestFields): SupportRequest => ({
  type: 'signup_help',
  name: request.name,
  email: request.email,
  phone_number: request.phoneNumber,
  date_of_birth: request.dateOfBirth,
  member_id: request.memberID,
  access_code: request.accessCode,
  hospital_id: request.hospitalID,
  invited_by: request.invitedBy,
  state_of_residence: request.stateOfResidence,
  source_screen: request.sourceScreen,
  app_name: `${request.appName} web`,
  app_version: request.appNameWithVersion,
  language: request.language,
  device_type: request.deviceType,
  browser_type: request.browserType,
  browser_version: request.browserVersion,
});

export const prepareDeleteAccountRequest = (
  request: ZendeskDeleteRequestFields,
): DeleteAccountRequest => ({
  name: request.name,
  app_name: `${request.appName} web`,
  app_version: request.appNameWithVersion,
  device_type: request.deviceType,
  browser_type: request.browserType,
  browser_version: request.browserVersion,
});
